module.exports = __webpack_public_path__ + "img/9788995547274.68981d38.jpg";